import React from 'react';
import styles from './../styles/components/isMobile.module.scss';
import { Row, Col } from 'react-flexbox-grid';
const BRAND = require('./../assets/images/logo.png');

const IsMobile = () => {
  return (
    <section className={styles.__background}>
      <Row center="xs" className={styles.__wrapper}>
        <Col xs={12}>
          <figure>
            <img src={BRAND} alt="Lively brand identity"/>
          </figure>
        </Col>
        <Col xs={12}>
          <p>Liveli Web only works in Tablet and Desktop devices.</p>
        </Col>
        <Col xs={12}>
          <small>Mobile version coming soon.</small>
        </Col>
      </Row>
    </section>
  )
}

export default IsMobile;
